import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import FadeIn from "./FadeIn";
import { orange } from "@mui/material/colors";

export default function Copyright() {
    const ref = React.useRef<HTMLDivElement>(null);
    return (
      <FadeIn duration={1000} delay={1000}>
        <Typography ref={ref} id="copyright-text" variant="h6" sx={{ fontFamily: 'inherit', textAlign: 'center', width: '100%', fontSize: '0.8rem', marginBottom: 2 }}>
          {`© ${new Date().getFullYear()}${ref.current?.clientWidth < 200 ? '' : ', All rights reserved by'}`}<br/>
          {ref.current?.clientWidth > 200 ? <span style={{color: orange[800]}}>IDEA</span> : ''}
        </Typography>
      </FadeIn>
    );
  }